import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    nav: {
      home: '首页',
      orders: '购买记录',
      cz: '充值',
      profile: '我的',
      login: '登录',
      logout: '退出登录'
    },
    footer: {
      discreet: '私密包装 · 安全购物'
    },
    common: {
      loading: '加载中...',
      buy: '立即购买',
      soldOut: '已售罄',
      back: '返回',
      price: '价格',
      quantity: '数量',
      total: '合计',
      confirm: '确认购买',
      cancel: '取消',
      noData: '暂无数据',
      success: '操作成功',
      loginRequired: '请先登录',
      networkError: '网络异常，请稍后重试'
    },
    home: {
      title: '私密用品商城',
      subtitle: '精选商品 · 私密包装 · 安心购买',
      products: '精选商品',
      empty: '暂时没有商品',
      viewDetail: '查看详情',
	  TopProvince:'最高省',
	  originalPrice:"原价",
	  lowestPrice:"最低价"
    },
    detail: {
      description: '商品介绍',
      stock: '库存',
      sales: '销量',
      quantity: '购买数量',
      buyNow: '立即购买',
      soldOut: '商品已售罄'
    },
    login: {
      title: '欢迎回来',
      subtitle: '登录你的商城账户',
      username: '用户名',
      password: '密码',
      usernamePlaceholder: '请输入用户名',
      passwordPlaceholder: '请输入密码',
      submit: '登录',
      noAccount: '还没有账户？',
      register: '立即注册',
      success: '登录成功'
    },
    register: {
      title: '创建账户',
      subtitle: '注册后即可开始购买',
      username: '用户名',
      password: '密码',
      confirmPassword: '确认密码',
      usernamePlaceholder: '请输入用户名',
      passwordPlaceholder: '请输入密码',
      confirmPlaceholder: '请再次输入密码',
      submit: '注册',
      hasAccount: '已有账户？',
      login: '立即登录',
      passwordMismatch: '两次密码不一致',
      success: '注册成功，请登录'
    },
    orders: {
      title: '购买记录',
      orderNo: '订单号',
      amount: '金额',
      status: '状态',
      completed: '已完成',
      time: '购买时间',
      detail: '订单详情',
      empty: '暂无购买记录'
    },
    profile: {
      title: '个人中心',
      username: '用户名',
      nickname: '昵称',
      balance: '余额',
      role: '账户类型',
      user: '普通用户',
      admin: '管理员'
    },
    buy: {
      title: '确认购买',
      success: '购买成功',
      orderNo: '订单号',
      amount: '订单金额'
    }
  },
  en: {
    nav: {
      home: 'Home',
      orders: 'Orders',
cz: 'Top up',
      profile: 'Profile',
      login: 'Login',
      logout: 'Logout'
    },
    footer: {
      discreet: 'Discreet packaging · Secure shopping'
    },
    common: {
      loading: 'Loading...',
      buy: 'Buy Now',
      soldOut: 'Sold Out',
      back: 'Back',
      price: 'Price',
      quantity: 'Quantity',
      total: 'Total',
      confirm: 'Confirm Purchase',
      cancel: 'Cancel',
      noData: 'No data',
      success: 'Success',
      loginRequired: 'Please login first',
      networkError: 'Network error, please try again'
    },
    home: {
      title: 'Private Shop',
      subtitle: 'Selected products · Discreet packaging · Secure shopping',
      products: 'Featured Products',
      empty: 'No products available',
      viewDetail: 'View Details',
	  TopProvince:'Save up to',
	  originalPrice:"Was ",
	  lowestPrice:"From "
    },
    detail: {
      description: 'Description',
      stock: 'Stock',
      sales: 'Sales',
      quantity: 'Quantity',
      buyNow: 'Buy Now',
      soldOut: 'Sold Out'
    },
    login: {
      title: 'Welcome Back',
      subtitle: 'Sign in to your account',
      username: 'Username',
      password: 'Password',
      usernamePlaceholder: 'Enter username',
      passwordPlaceholder: 'Enter password',
      submit: 'Login',
      noAccount: 'No account?',
      register: 'Register'
    },
    register: {
      title: 'Create Account',
      subtitle: 'Register to start shopping',
      username: 'Username',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      usernamePlaceholder: 'Enter username',
      passwordPlaceholder: 'Enter password',
      confirmPlaceholder: 'Enter password again',
      submit: 'Register',
      hasAccount: 'Already have an account?',
      login: 'Login',
      passwordMismatch: 'Passwords do not match',
      success: 'Registration successful, please login'
    },
    orders: {
      title: 'Purchase History',
      orderNo: 'Order No.',
      amount: 'Amount',
      status: 'Status',
      completed: 'Completed',
      time: 'Purchase Time',
      detail: 'Order Details',
      empty: 'No purchase history'
    },
    profile: {
      title: 'Profile',
      username: 'Username',
      nickname: 'Nickname',
      balance: 'balance',
      role: 'Account Type',
      user: 'User',
      admin: 'Administrator'
    },
    buy: {
      title: 'Confirm Purchase',
      success: 'Purchase Successful',
      orderNo: 'Order No.',
      amount: 'Order Amount'
    }
  }
}

const locale = localStorage.getItem('locale') || 'en'

export default new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages
})
